export default "__VITE_ASSET__agajAnk2__"